import Utils from 'services/utils';

export default class FoldersController {
    /** @ngInject */
    constructor(Loader, FolderService, DialogService, ToastService, $state, $scope) {
        this.Loader = Loader;
        this.FolderService = FolderService;
        this.DialogService = DialogService;
        this.ToastService = ToastService;
        this.$state = $state;
        this.$scope = $scope;
    }

    get currentFolderId() {
        return this.$state.params.folderId;
    }

    $onInit() {
        this.foldersLoading = false;
        this.folders = this.FolderService.getTree();
        this.searchIndex = this.prepareSearchIndex();
    }

    prepareSearchIndex() {
        const data = [];
        Object.keys(this.FolderService.folderMap).forEach((folderId) => {
            const folderPath = this.FolderService.buildFolderPath(folderId);
            const name = folderPath.map(folder => folder.name).join(' > ');
            data.push({
                id: folderId,
                name
            });
        });
        return Utils.buildSearchIndex(data);
    }

    onSearch({ query }) {
        return Utils.searchInIndex(this.searchIndex, query);
    }

    onFolderFound({ item }) {
        if (item) {
            if (!this.currentFolderId || this.currentFolderId !== item.id) {
                this.$scope.$broadcast('angular-ui-tree:collapse-all');
            }
            const folder = this.FolderService.getFolder(item.id);
            this.editFolder({
                folder
            });
        }
    }

    moveFolder({ folder, parent, index }) {
        this.Loader.show();
        this.foldersLoading = true;
        this.FolderService.moveFolder(folder, parent, index)
            .then(() => {
                this.searchIndex = this.prepareSearchIndex();
                this.showToast('folder_was_moved');
            })
            .catch(() => {
                this.showToast('folder_wasnt_moved');
            })
            .finally(() => {
                this.foldersLoading = false;
                this.Loader.hide();
            });
    }

    showToast(textKey) {
        this.ToastService.showSimpleTranslated(textKey);
    }

    createFolder({ folder: data }) {
        this.Loader.show();
        return this.FolderService.addFolder(data)
            .then((folder) => {
                this.showToast('folder_was_created');
                this.searchIndex = this.prepareSearchIndex();
                this.$state.go('main.folders-and-labels.folders.folder', {
                    folderId: folder.id
                });
            }, () => {
                this.showToast('folder_wasnt_created');
            })
            .finally(() => {
                this.Loader.hide();
            });
    }

    showSensors() {
        this.$state.go('main.sensors.list', {
            folderId: this.currentFolderId
        });
    }

    editFolder({ folder }) {
        this.$state.go('main.folders-and-labels.folders.folder', {
            folderId: folder.id
        });
    }

    cancelEdit() {
        this.$state.go('main.folders-and-labels.folders');
    }

    saveFolder({ folder }) {
        this.Loader.show();
        this.FolderService
            .saveFolder(folder)
            .then(() => {
                this.searchIndex = this.prepareSearchIndex();
                this.showToast('folder_was_updated');
            }, () => {
                this.showToast('folder_wasnt_updated');
            })
            .finally(() => {
                this.Loader.hide();
            });
    }

    deleteFolder({ folder }) {
        this.Loader.show();
        this.FolderService
            .deleteFolder(folder)
            .then(() => {
                this.searchIndex = this.prepareSearchIndex();
                this.showToast('folder_was_removed');
            }, () => {
                this.showToast('folder_wasnt_removed');
            })
            .finally(() => {
                this.Loader.hide();
            });
        this.cancelEdit();
    }
}



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folders.controller.js